import gsap from 'gsap'
import store from './store'

export default class PopUpForm {
  constructor(formId) {
    this.formOpened = false
    this.lenis = store.smoothScroll
    this.formId = formId
    this.getElems()
    this.gsapSet()
    this.events()
  }

  getElems() {
    // Select the elements that match this form's ID
    this.fixedButton = document.querySelector(`.e-button-pop-up-form[data-form-id="${this.formId}"]`)
    this.openButtons = document.querySelectorAll(`.--open-pop-up-form[data-form-id="${this.formId}"]`)
    this.popUp = {
      el: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"]`),
      content: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .c-pop-up-form__content`),
      close: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .c-pop-up-form__content__close`),
      background: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .c-pop-up-form__background`),
      formWrapper: document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .gform_wrapper`),
    }
    this.submitButton = document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"] .e-button`)
    this.requiredFields = [...document.querySelectorAll(`
      .c-pop-up-form[data-form-id="${this.formId}"] [aria-required="true"],
      .c-pop-up-form[data-form-id="${this.formId}"] [aria-required="true"],
      .c-pop-up-form[data-form-id="${this.formId}"] [aria-required="true"]
    `)]
  }

  gsapSet() {
    if (this.popUp.el) {
      gsap.set(this.popUp.el, {
        visibility: 'hidden',
        opacity: 0
      })

      gsap.set(this.popUp.content, {
        xPercent: 100
      })

      gsap.set(this.popUp.background, {
        opacity: 0
      })
    }
  }

  events() {
    this.submitButton.disabled = true

    if (this.fixedButton) {
      this.fixedButton.addEventListener('click', () => {
        this._openForm()
      })
    }

    if (this.popUp.el) {
      document.addEventListener('click', (e) => {
        if (this.formOpened && !this.popUp.content.contains(e.target)) {
          this._closeForm()
        }
      })

      this.popUp.close.addEventListener('click', () => {
        this._closeForm()
      })

      this.popUp.background.addEventListener('click', () => {
        this._closeForm()
      })

      this.popUp.content.addEventListener('wheel', (e) => e.stopPropagation())

      if (this.openButtons) {
        this.openButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this._openForm()
          })
        })
      }
    }

    this._checkRequiredFields = this._checkRequiredFields.bind(this)
    document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"]`).addEventListener('input', this._checkRequiredFields)
    document.querySelector(`.c-pop-up-form[data-form-id="${this.formId}"]`).addEventListener('change', this._checkRequiredFields)
  }

  _checkRequiredFields() {
    let allFieldsValid = true

    this.requiredFields.forEach((field) => {
      if (!field.value || field.type === 'checkbox' && !field.checked) {
        allFieldsValid = false
      }
    })

    this.submitButton.disabled = !allFieldsValid
  }

  _openForm() {
    if (this.popUp.formWrapper) {
      this.popUp.formWrapper.scrollTop = 0
    }
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`
    document.documentElement.classList.add('form-opened')
    this.lenis.stop()
    const tlOpen = gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: 'power3.out'
      },
      onComplete: () => {
        this.formOpened = true
      }
    })

    tlOpen.to(this.popUp.el, {
      visibility: 'visible',
      opacity: 1,
      duration: 0
    })
    .to(this.popUp.background, {
      opacity: 1
    })
    .to(this.popUp.content, {
      xPercent: 0
    }, '<+0.2')

    tlOpen.play()
  }

  _closeForm() {
    document.documentElement.style.paddingRight = ''
    document.documentElement.classList.remove('form-opened')
    this.lenis.start()
    const tlClose = gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: 'power3.out'
      },
      onComplete: () => {
        this.formOpened = false
      }
    })

    tlClose.to(this.popUp.content, {
      xPercent: 100
    })
    .to(this.popUp.background, {
      opacity: 0
    }, '<+0.2')
    .to(this.popUp.el, {
      visibility: 'hidden',
      opacity: 0,
      duration: 0
    })

    tlClose.play()
  }
}
